import { fieldComparator } from "@/helpers/helpers";
import { CONTENT_TYPE_SLUGS, TABLE_TYPES } from "@/helpers/constants";

export default {
  /**
   * Get current user table
   */
  userTable: (state, getters, rootState, rootGetters) => {
    let tableId = rootGetters["users/userAssignment"] ? rootGetters["users/userAssignment"].table_id : null;
    if (tableId) {
      return (
        getters.tables().find(table => {
          return table.TABLE_ID === tableId;
        }) || null
      );
    } else {
      return null;
    }
  },

  /**
   * Get sorted list of users for table with tableUUID
   */
  tableUsers: (state, getters) => tableUUID => {
    return [...getters.tableState(tableUUID)].sort(fieldComparator(["firstName", "lastName"]));
  },

  /**
   * Get sponsor tables in current Room
   */
  sponsorTables: (state, getters) => {
    return getters.tables().filter(t => {
      return t.TABLE_TYPE === TABLE_TYPES.SPONSOR && getters.isTableVisible(t);
    });
  },

  /**
   * Get VIP tables in current Room
   */
  vipTables: (state, getters) => {
    return getters.tables().filter(t => t.TABLE_TYPE === TABLE_TYPES.VIP && getters.isTableVisible(t));
  },

  /**
   * Get In Person Guests tables in current Room
   */
  inPersonGuests: (state, getters) => {
    return getters.tables().filter(t => t.TABLE_TYPE === TABLE_TYPES.IN_PERSON_GUESTS && getters.isTableVisible(t));
  },

  /**
   * Get guest tables in current Room
   */
  guestTables: (state, getters) => {
    return getters.tables().filter(t => {
      return (
        t.TABLE_TYPE === TABLE_TYPES.VIRTUAL_GUESTS &&
        t.ASSIGNMENTS.length &&
        (!t.IS_DYNAMIC || (t.IS_DYNAMIC && getters.tableUsersByAssignments(t.ASSIGNMENTS).length))
      );
    });
  },

  /**
   * Get public table - table where will be placed all people with public domains (gmail.com, mail.ru, etc.)
   */
  publicTable: (state, getters) => {
    let publicTables = getters.tables().filter(t => t.TABLE_TYPE === TABLE_TYPES.PUBLIC_GALLERY);
    return publicTables.length ? publicTables[0] : null;
  },
  /**
   * Get table users by assignments
   * @param assignments
   */
  tableUsersByAssignments: (state, getters, rootState, rootGetters) => assignments => {
    return rootGetters["room/roomState"].filter(user => {
      return assignments.includes(user.email) || assignments.includes(user.emailDomain);
    });
  },

  /**
   * Get table state
   * @param state
   * @param getters
   */
  tableState: (state, getters, rootState, rootGetters) => tableUUID => {
    tableUUID = tableUUID || getters.userTable.uuid;
    return rootGetters["room/roomState"].filter(user => {
      return user.tableUUID === tableUUID;
    });
  },

  /**
   * Get assignment method data
   * @param state
   * @param getters
   * @param rootState
   */
  assignmentMethod: (state, getters, rootState) => {
    return JSON.parse(rootState.event.context.children.DigitalEventRoom[0].ASSIGNMENT_METHOD_TABLE);
  },

  /**
   * Get table list for room
   * @param state {Object}
   * @param getters {Object}
   * @return {function(*): *}
   */
  tables: (state, getters, rootState, rootGetters) => room => {
    room = room || rootGetters["room/activeRoom"] || null;
    let tables = room ? room.children[CONTENT_TYPE_SLUGS.DIGITAL_EVENT_TABLE] || [] : [];
    return [...tables].sort(fieldComparator("TITLE", null));
  },

  /**
   * Check: has table in|out users
   * @param state {Object}
   * @param getters {Object}
   * @return {function(*): boolean}
   */
  hasTableInOutUsers: (state, getters) => table => {
    return Boolean(getters.tableUsersByAssignments(table.ASSIGNMENTS).length);
  },

  /**
   * Check: can we display this table
   * @param state {Object}
   * @param getters {Object}
   * @return {function(*)}
   */
  isTableVisible: (state, getters) => table => {
    return !table.ASSIGNMENT_METHOD_TABLE || (table.ASSIGNMENT_METHOD_TABLE && getters.hasTableInOutUsers(table));
  },

  /**
   * Table by uuid
   * @param state {Object}
   * @param getters {Object}
   * @return {function(*): *}
   */
  table: (state, getters) => tableUUID => {
    return getters.tables().find(table => table.uuid === tableUUID);
  },

  /**
   *
   * @param state
   * @param getters
   * @returns {function(*): *}
   */
  tableByUser: (state, getters, rootState, rootGetters) => user => {
    return getters.tables(rootGetters["room/room"](user.roomUUID)).find(table => table.uuid === user.tableUUID);
  },

  /**
   *
   * @param state
   * @param getters
   */
  publicTableUsers: (state, getters) => {
    return getters.publicTable ? getters.tableUsers(getters.publicTable.uuid) : [];
  },
  /**
   *
   * @param state
   * @param getters
   */
  isPublicGallery: (state, getters) => {
    return getters.userTable.TABLE_TYPE === TABLE_TYPES.PUBLIC_GALLERY;
  },
  /**
   *
   * @param state
   * @param getters
   * @returns {function(*): *}
   */
  isInPublicGallery: (state, getters) => user => {
    return getters.tableByUser(user).TABLE_TYPE === TABLE_TYPES.PUBLIC_GALLERY;
  }
};
